import { Icon } from "@iconify/react";
import { Box, HStack, VStack } from "../utils";

export function Instructions(props: { data: any; seperator?: string }) {
  const { data, seperator } = props;
  let convertedData: string[] = [];
  if (!data) return <></>;
  if (data instanceof Array) {
    convertedData = data;
  } else if (typeof data === "string") {
    convertedData = data.split(seperator || ",");
  } else {
    return <></>;
  }

  return (
    <VStack className="p-2 text-black-501 bg-yellow-100 rounded">
      <HStack className="pt-0 justify-start">
        <HStack className="gap-1 pl-1 items-center">
          <Icon
            icon="material-symbols:info-outline-rounded"
            height={18}
            width={18}
            className="w-full text-xs font-medium text-black-501 rounded"
          />
          <p className="text-sm">Note </p>
        </HStack>
      </HStack>
      <Box className="pl-5 pt-2 pb-1">
        <ul className="list-disc">
          {convertedData.map((info, index) => (
            <li key={index} className="text-xs pt-0.5">
              {info}
            </li>
          ))}
        </ul>
      </Box>
    </VStack>
  );
}
